import { render, staticRenderFns } from "./WithdrawList.vue?vue&type=template&id=385336b2&scoped=true&"
import script from "./WithdrawList.vue?vue&type=script&lang=js&"
export * from "./WithdrawList.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawList.vue?vue&type=style&index=0&id=385336b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385336b2",
  null
  
)

export default component.exports